import { render, staticRenderFns } from "./ConsoleMenuCompared.vue?vue&type=template&id=6d87cfba&scoped=true&"
import script from "./ConsoleMenuCompared.vue?vue&type=script&lang=js&"
export * from "./ConsoleMenuCompared.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleMenuCompared.vue?vue&type=style&index=0&id=6d87cfba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d87cfba",
  null
  
)

export default component.exports